export default "__VITE_ASSET__DgjhRFiQ__"